import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Skeleton,
  useDisclosure,
} from "@chakra-ui/react";

import React, { lazy, Suspense } from "react";

const ReactPlayer = lazy(() => import("react-player"));

function ShowCaseTrailerModal({
  url,
  actionEl,
  onClick,
}: {
  url: string;
  actionEl?: React.ReactElement;
  onClick?: () => void;
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (!url) return null;

  return (
    <>
      {actionEl ? (
        React.cloneElement(actionEl, {
          onClick: (e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            onClick && onClick();
            onOpen();
          },
        })
      ) : (
        <Button
          onClick={(e) => {
            e.stopPropagation();
            onOpen();
            onClick && onClick();
          }}
        >
          View Video
        </Button>
      )}

      <Modal isCentered isOpen={isOpen} onClose={onClose}>
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          minW="60vw"
          minH="70vh"
          background="surface.10"
          sx={{
            padding: 0,
          }}
          position="initial"
        >
          <ModalCloseButton
            borderRadius="full"
            background="blackAlpha.100"
            _hover={{
              background: "blackAlpha.300",
            }}
            color="black"
          />
          <ModalBody p={0}>
            <Suspense
              fallback={
                <Skeleton width="100%" height="70vh" borderRadius="md" />
              }
            >
              <ReactPlayer url={url} width="100%" height="70vh" />
            </Suspense>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
export default ShowCaseTrailerModal;
